module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/product/product-create/product-create.component.scss
// module id = ./src/app/routes/product/product-create/product-create.component.scss
// module chunks = 9